import TrackingService from '@/services/tracking';
import React, { RefObject } from 'react';
import {
  BaseButton,
  Box,
  HStack,
  IconButton,
  pickColor,
  Text,
} from 'remodeling-web-mobile-sdk-ui';
import styled, { css } from 'styled-components';
import Delete from '../svg/Delete';

interface SearchZoneCodeInputProps {
  handleSearchSubmit: (e: React.FormEvent<HTMLFormElement>) => Promise<void>;
  inputValue: string;
  handleChangeInput: (e: React.FormEvent<HTMLInputElement>) => void;
  inputError: string;
  handleClickDelete: () => void;
  inputRef:
    | ((instance: HTMLInputElement | null) => void)
    | RefObject<HTMLInputElement>
    | null
    | undefined;
}

const SearchZoneCodeInput = ({
  handleSearchSubmit,
  inputValue,
  handleChangeInput,
  inputError,
  handleClickDelete,
  inputRef,
}: SearchZoneCodeInputProps) => {
  return (
    <Box as="section" position="relative" mb={38} padding="10px 16px">
      <form onSubmit={handleSearchSubmit}>
        <StyledInput
          type="text"
          placeholder="도로명, 지번, 건물명"
          value={inputValue}
          onChange={handleChangeInput}
          ref={inputRef}
        />
        {inputError !== '' && (
          <Text
            variant="body3"
            color={pickColor('etc_color.error')}
            mt="8px"
            ml="20px"
          >
            {inputError}
          </Text>
        )}
        <HStack position="absolute" top="14px" right="28px" height="32px">
          {inputValue && (
            <BaseButton
              onClick={handleClickDelete}
              type="button"
              padding="0"
              pt="3px"
              mr="8px"
            >
              <Delete
                {...TrackingService.tagGTM('search_zone_code_delete_button')}
              />
            </BaseButton>
          )}
          <IconButton
            variant="ic_search_bold_32"
            padding="0"
            type="submit"
            {...TrackingService.tagGTM('search_zone_code_submit_button')}
          />
        </HStack>
      </form>
    </Box>
  );
};

const StyledInput = styled.input`
  ${({ theme }) => css`
    box-sizing: border-box;
    background-color: ${theme.colors.natural_color.gray[50]};
    width: 100%;
    height: 40px;
    border: 0;
    -webkit-border-radius: 20px !important;
    border-radius: 20px !important;
    padding: 10px 76px 10px 20px;
    ${theme.typography.body2};
    color: ${theme.colors.accent_color.primary.default};
    caret-color: ${theme.colors.accent_color.secondary.red};
    &::placeholder {
      color: ${theme.colors.natural_color.gray[500]};
    }
  `}
`;

export default SearchZoneCodeInput;
